// extracted by mini-css-extract-plugin
export default {"overrides":"_SIYmI","fadeIn":"wNW36F","changing_background":"JqqXMV","changingBackground":"JqqXMV"};